module.exports = __webpack_public_path__ + "img/ship2.9d86b0c5.jpg";